import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

declare var $: any;

export class SelectItem {
  value: any;
  name: any;
}

@Component({
  standalone: false,
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent implements AfterViewInit {

  @Input()
  options: SelectItem[] = [];

  @Output()
  valueChange = new EventEmitter<any>();

  valueSelected?: any;

  constructor() {
  }

  ngAfterViewInit() {
    if ($('.selectpicker').length != 0) {
      $('.selectpicker').selectpicker({
        style: 'btn-white',
        iconBase: 'fa',
        tickIcon: 'fa-check'
      });
    }
  }

  onChange(value: any) {
    this.valueSelected = value;
    this.valueChange.emit(this.valueSelected);
  }
}
